type Attrs = Record<string, unknown>;

function filterAllAttrs (type: 'listeners' | 'attrs-no-style-no-class', allAttrs: Attrs) {
  const obj: Attrs = {};
  for (const attrKey in allAttrs) {
    const isEvent = attrKey.startsWith('on');
    if (
      (type === 'listeners' && isEvent) ||
      (type === 'attrs-no-style-no-class' && !isEvent && attrKey !== 'style' && attrKey !== 'class')
    ) {
      obj[attrKey] = allAttrs[attrKey];
    }
  }
  return obj;
}

export function awListeners (attrs: Attrs) {
  return filterAllAttrs('listeners', attrs);
}
export function awAttrsNoListeners (attrs: Attrs) {
  return {
    ...awAttrsNoStyleNoClassNoListeners(attrs),
    style: attrs.style,
    class: attrs.class,
  };
}
export function awAttrsNoStyleNoClassNoListeners (attrs: Attrs) {
  return filterAllAttrs('attrs-no-style-no-class', attrs);
}
